var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#D8FFEE",
    stroke: "#36B37E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16C10 16 14.4772 11 20 11C25.5228 11 30 16 30 16",
    stroke: "#36B37E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.544 21.045C29.848 21.4713 30 21.6845 30 22C30 22.3155 29.848 22.5287 29.544 22.955C28.1779 24.8706 24.6892 29 20 29C15.3108 29 11.8221 24.8706 10.456 22.955C10.152 22.5287 10 22.3155 10 22C10 21.6845 10.152 21.4713 10.456 21.045C11.8221 19.1294 15.3108 15 20 15C24.6892 15 28.1779 19.1294 29.544 21.045Z",
    stroke: "#36B37E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22C23 20.3431 21.6569 19 20 19C18.3431 19 17 20.3431 17 22C17 23.6569 18.3431 25 20 25C21.6569 25 23 23.6569 23 22Z",
    stroke: "#36B37E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.9aad89931e56c47b65087f0f285bcba7.svg";
export { ForwardRef as ReactComponent };